module.exports = __webpack_public_path__ + "img/apple-iphone-5s.2fa16224.png";